











































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import _ from 'lodash';

import { CatastrophicFollowUpLookupModel, CatastrophicFollowUpModel, CatastrophicInjuryModel } from '@/core/webapi';
import { AutoSaveService, ApiService } from '@/core/services';
import { QcFormElementWithAlertCpt } from '../components';
import {
  BaseFormComponent,
  InputFieldCpt,
  InputTextareaCpt,
  InputDateCpt,
  InputSelectCpt,
  InputRadioCpt,
  InputSwitchCpt,
  InputYesNoNotKnownCpt,
  ValidationHintCpt,
  SpinnerCpt,
} from '@/core/components';
import AsiaGcsGosCpt from './AsiaGcsGosCpt.vue';

@Component({
  components: {
    QcFormElementWithAlertCpt,
    InputFieldCpt,
    InputTextareaCpt,
    InputDateCpt,
    InputSelectCpt,
    InputRadioCpt,
    InputSwitchCpt,
    InputYesNoNotKnownCpt,
    ValidationHintCpt,
    SpinnerCpt,
    AsiaGcsGosCpt,
  },
})
export default class CatastrophicFollowUpFormView extends BaseFormComponent {
  lookups = {} as CatastrophicFollowUpLookupModel;
  model = new CatastrophicFollowUpModel({ modelState: {} } as any);
  comparisonModel: CatastrophicFollowUpModel;
  pickerOptions = {
    disabledDate(time: any) {
      return time.getTime() > Date.now();
    },
  };
  autoSaveTimeoutId?: number;
  loading = true;
  asiaLookups = [
    { id: 'A', text: 'A' },
    { id: 'B', text: 'B' },
    { id: 'C', text: 'C' },
    { id: 'D', text: 'D' },
    { id: 'E', text: 'E' },
  ];

  get injuryId() {
    return this.getUrlParamAsNumber('injuryId');
  }

  get autoSaveId() {
    return this.getUrlParamAsNumber('autoSaveId');
  }

  async created() {
    this.model.id = this.injuryId!;

    try {
      await this.initializeModel();
      await this.initializeLookupData();
      this.initializeAutoSave();
    } finally {
      this.loading = false;
    }
  }

  destroyed() {
    this.clearAutoSaveTimeout();
  }

  onAnyProceduresSince(anyProceduresSince: boolean) {
    if (anyProceduresSince) {
      if (!this.model.procedures?.length) {
        this.model.procedures = [];
        this.addNewProcedure();
      }
    }
  }

  addNewProcedure() {
    this.model.procedures?.push({ dateOfProcedure: null as any, description: '' });
  }

  removeProcedure(index: number) {
    this.model.procedures?.splice(index, 1);
  }

  async onSubmitForm() {
    this.clearAutoSaveTimeout();

    try {
      this.model.followUpId
        ? await ApiService.catastrophicInjuries()
            .updateCatastrophicFollowUp(this.model)
            .handleValidationErrors(this.model)
        : await ApiService.catastrophicInjuries()
            .createCatastrophicFollowUp(this.model)
            .handleValidationErrors(this.model);
    } catch (e) {
      // Typically we can allow the failed request (422) to stop the execution flow of onSubmitForm(),
      // but it breaks the autoSave feature timeout, so we need to handle it explicitly
      return;
    }

    this.$notify({
      title: this.$t('Success') as string,
      message: this.$t('Follow up saved') as string,
      type: 'success',
    });

    if (this.model.autoSaveId) {
      await ApiService.autoSave().deleteAutoSave(this.model.autoSaveId);
      this.clearAutoSaveTimeout();
    }

    this.$router.push('/catastrophic-injuries');
  }

  async discard() {
    const message = this.$t('Are you sure you want to discard local changes for this report?') as string;
    if (!confirm(message)) {
      return;
    }

    this.clearAutoSaveTimeout();
    if (!this.model.autoSaveId) {
      return;
    }

    if (this.model.autoSaveId) {
      await ApiService.autoSave().deleteAutoSave(this.model.autoSaveId);
    }

    this.$router.push('/catastrophic-injuries');
  }

  private async initializeModel() {
    if (this.injuryId) {
      const model = await this.getModel(this.injuryId);
      if (model) {
        _.extend(this.model, model);
      }
    } else if (this.autoSaveId) {
      const model = await AutoSaveService.getCatastrophicFollowUpAutoSave(this.autoSaveId);
      if (model) {
        _.extend(this.model, model);
      }
    }

    this.updateComparisonModel();
  }

  private async getModel(injuryId: number) {
    if (this.isReporter) {
      const autoSave = await AutoSaveService.findCatastrophicFollowUpAutoSave(injuryId);
      if (autoSave) {
        return autoSave;
      }
    }

    return (await ApiService.catastrophicInjuries()
      .getCatastrophicFollowUp(injuryId)
      .getDataAndDefaultValidationProps()) as CatastrophicInjuryModel;
  }

  private async initializeLookupData() {
    this.lookups = (await ApiService.catastrophicInjuries().getCatastrophicFollowUpFormLookupData()).data;
    this.updateComparisonModel();
  }

  private updateComparisonModel() {
    this.comparisonModel = JSON.parse(JSON.stringify(this.model)); // Make a copy
  }

  private initializeAutoSave() {
    if (!this.isReporter) {
      // Auto-saving is only for reporters really
      return;
    }

    this.clearAutoSaveTimeout();

    this.autoSaveTimeoutId = setTimeout(async () => {
      if (!this.$auth.isAuthenticated()) {
        return;
      }

      if (this.autoSaveTimeoutId) {
        const autoSave = await AutoSaveService.autoSaveCatastrophicFollowUp(this.model, this.comparisonModel);
        if (!!autoSave) {
          this.model.autoSaveId = autoSave.id;
          this.updateComparisonModel();
        }
        this.initializeAutoSave();
      }
    }, 5000);
  }

  private clearAutoSaveTimeout() {
    if (this.autoSaveTimeoutId) {
      clearTimeout(this.autoSaveTimeoutId);
      this.autoSaveTimeoutId = undefined;
    }
  }
}
